<template>
  <div class="page document-detail">
    <div class="lang-box">
      <el-radio-group v-model="type" size="medium" >
        <el-radio-button v-if="documentInfo.type == '1' || documentInfo.type == '3'" label="1">中文</el-radio-button>
        <el-radio-button v-if="documentInfo.type == '2' || documentInfo.type == '3'" label="2">英文</el-radio-button>
      </el-radio-group>
    </div>
    <el-scrollbar v-if="type=='1'" ref="view-box" style="position: relative;width:100%;height:100%;box-sizing: border-box;">
      <div class="view-box">
        <div class="html"  v-html="documentInfo.content"></div>
      </div>
    </el-scrollbar>
    <el-scrollbar v-if="type=='2'" ref="view-box" style="margin-top:20px;position: relative;width:100%;height:100%;box-sizing: border-box;">
      <div class="view-box">
        <div class="html"  v-html="documentInfo.englishContent"></div>
      </div>
    </el-scrollbar>
    <div class="foot">
      <el-button class="w150" type="primary" @click="onCancel()">返回</el-button>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    
  },
  mounted(){
    this.queryDocumentInfo();
  },
  data() {
    return {
      type:'1',
      documentInfo:''
    };
  },
  methods:{
    //获取详情
    queryDocumentInfo(){
      this.$apis.documentServer.queryDocumentInfo({
        id:this.$route.query.id,//	string	id
      })
      .then((res) => {
        if (res.code == 0) {
          this.documentInfo = res.data;
          if(this.documentInfo.type == '1'){
            this.type = '1'
          }
          if(this.documentInfo.type == '2'){
            this.type = '2'
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onCancel() {
      this.$router.replace({
        path: "/document/list",
        query:{
          docMenuId:this.$route.query.docMenuId,
          date:new Date().getTime()
        }
      });
    },
  }
};
</script>

<style  lang="scss">

/*主体*/
.document-detail{    
  margin-top: 20px;
  position: relative;
  .lang-box{
    position: absolute;
    top: -50px;
    right: 0px;
    cursor: pointer;
    z-index: 9;
  }
  .view-box{
    position: relative;
    padding: 60px;
    background: #Fff;
    .html{
      padding: 20px 0;
      img{
        max-width: 100%;
      }
      html, address,blockquote,body, dd, div,dl, dt, fieldset, form,frame, frameset,h1, h2, h3, h4,h5, h6, noframes,ol, p, ul, center,dir, hr, menu, pre   { display: block; unicode-bidi: embed }li              { display: list-item }head            { display: none }table           { display: table }tr              { display: table-row }thead           { display: table-header-group }tbody           { display: table-row-group }tfoot           { display: table-footer-group }col             { display: table-column }colgroup        { display: table-column-group }td, th          { display: table-cell }caption         { display: table-caption }th              { font-weight: bolder; text-align: center }caption         { text-align: center }body            { margin: 8px }h1              { font-size: 2em; margin: .67em 0 }h2              { font-size: 1.5em; margin: .75em 0 }h3              { font-size: 1.17em; margin: .83em 0 }h4, p,blockquote, ul,fieldset, form,ol, dl, dir,menu            { margin: 1.12em 0 }h5              { font-size: .83em; margin: 1.5em 0 }h6              { font-size: .75em; margin: 1.67em 0 }h1, h2, h3, h4,h5, h6, b,strong          { font-weight: bolder }blockquote      { margin-left: 40px; margin-right: 40px }i, cite, em,var, address    { font-style: italic }pre, tt, code,kbd, samp       { font-family: monospace }pre             { white-space: pre }button, textarea,input, select   { display: inline-block }big             { font-size: 1.17em }small, sub, sup { font-size: .83em }sub             { vertical-align: sub }sup             { vertical-align: super }table           { border-spacing: 2px; }thead, tbody,tfoot           { vertical-align: middle }td, th, tr      { vertical-align: inherit }s, strike, del  { text-decoration: line-through }hr              { border: 1px inset }ol, ul, dir,menu, dd        { margin-left: 40px }ol              { list-style-type: decimal }ol ul, ul ol,ul ul, ol ol    { margin-top: 0; margin-bottom: 0 }u, ins          { text-decoration: underline }br:before       { content: "\A"; white-space: pre-line }center          { text-align: center }:link, :visited { text-decoration: underline }:focus          { outline: thin dotted invert }/* Begin bidirectionality settings (do not change) */BDO[DIR="ltr"]  { direction: ltr; unicode-bidi: bidi-override }BDO[DIR="rtl"]  { direction: rtl; unicode-bidi: bidi-override }*[DIR="ltr"]    { direction: ltr; unicode-bidi: embed }*[DIR="rtl"]    { direction: rtl; unicode-bidi: embed }@media print {
      h1            { page-break-before: always }

      h1, h2, h3,

      h4, h5, h6    { page-break-after: avoid }

      ul, ol, dl    { page-break-before: avoid }}
      pre[class*="language-"]{
        border:0;
        box-shadow:none;
      }
    }
  }
  .foot {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
